const initializedBenefitsSections = new WeakSet();

const setBenefitState = (item, isOpen) => {
  const trigger = item.querySelector('.benefits-sec__trigger');
  const panel = item.querySelector('.benefits-sec__panel');

  if (!trigger || !panel) {
    return;
  }

  item.classList.toggle('is-open', isOpen);
  trigger.setAttribute('aria-expanded', String(isOpen));
  panel.setAttribute('aria-hidden', String(!isOpen));
  panel.toggleAttribute('inert', !isOpen);
};

const initBenefits = (scope = document) => {
  const sections = scope.matches?.('.benefits-sec')
    ? [scope]
    : scope.querySelectorAll('.benefits-sec');

  sections.forEach((section) => {
    if (initializedBenefitsSections.has(section)) {
      return;
    }

    const items = Array.from(section.querySelectorAll('.benefits-sec__item')).filter(
      (item) => item.querySelector('.benefits-sec__trigger') && item.querySelector('.benefits-sec__panel')
    );

    if (!items.length) {
      return;
    }

    initializedBenefitsSections.add(section);
    items.forEach((item, index) => setBenefitState(item, index === 0));

    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('.benefits-sec__trigger');

      if (!trigger || !section.contains(trigger)) {
        return;
      }

      const item = trigger.closest('.benefits-sec__item');

      if (!item || !items.includes(item)) {
        return;
      }

      const shouldOpen = !item.classList.contains('is-open');
      items.forEach((currentItem) => setBenefitState(currentItem, currentItem === item && shouldOpen));
    });
  });
};

initBenefits();
window.initBenefits = initBenefits;
